import { instanciaAxios } from '@/services/base.service';
import store from '@/store';
import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { DDDInterface } from '@/shared/models/ddd/ddd.interface';
import { AxiosError, AxiosResponse } from 'axios';

const ddd = 'ddd';

export default class DDDService {
  async buscarTodos(): Promise<Array<DDDInterface> | null> {
    return await instanciaAxios.get(ddd)
      .then((response: AxiosResponse<Array<DDDInterface>>) => response.data)
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
        return null;
      });
  }
}
